import { call, put, takeLatest } from "redux-saga/effects";
import { getCall } from "../../../helpers/fakebackend_helper";

//restapi end point
import * as constClass from "../../../common/constant/constantURL";
import {
  SEND_REMINDER,
  TIME_LINE_DETAIL
} from "./actionTypes";

import {
  sendReminderFailed,
  sendReminderSuccess,
  timeLineDetailFailed,
  timeLineDetailSuccess
} from "./actions";

function* timeLineDetail({payload:{data}}){
    try{
      let url=constClass.REST_API_TIME_LINE_DETAIL+`candidateId=${encodeURIComponent(data.candidateId)}&jobId=${encodeURIComponent(data.jobId)}`
      let responsJSON=yield call(getCall,url)
      yield put(timeLineDetailSuccess(responsJSON))
  
    }
    catch(error){
     
      yield put(timeLineDetailFailed(error))
  
  
    }
  }
  
  function* sendReminder({payload:{data}}){
    try{
      let url=constClass.REST_API_SEND_REMINDER+`candidateId=${encodeURIComponent(data.candidateId)}&jobId=${encodeURIComponent(data.jobId)}&stage=${data.stage}`
      let responsJSON=yield call(getCall,url)
      yield put(sendReminderSuccess(responsJSON))
  
    }
    catch(error){
     
      yield put(sendReminderFailed(error))
    }
  }
  

function* timeLineSaga() {
  yield takeLatest(TIME_LINE_DETAIL, timeLineDetail);
  yield takeLatest(SEND_REMINDER, sendReminder);
 
}

export default timeLineSaga;
